import React, { FC } from 'react'

import styled from 'styled-components'

import { HUNDRED } from 'src/Constants/numeric'
import { variables, device, MAX_MOBILE_WIDTH } from 'src/Styled/variables'

export const ReferAndEarnProgressTestId = {
  firstDot: 'first-dot',
  secondDot: 'second-dot',
  thirdDot: 'third-dot',
}

export interface ReferAndEarnProgressProps {
  count: number
}
const MIDDLE_COUNT = 4
const LAST_COUNT = 10

export const OuterWrapper = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  @media ${device.mobileMin} {
    flex-direction: column-reverse;
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 24px;
  width: 100%;
  @media ${device.mobileMin} {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const DotsBlock = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 8px;

  @media ${device.mobileMin} {
    flex-direction: row;
    gap: 8px;
  }
`
export const DotOuter = styled.div<{ $isActive: boolean }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: relative;
  display: flex;
  flex-shrink: 0;
  background-color: ${({ theme, $isActive }) =>
    $isActive ? theme.color.lightGreen : theme.color.lightGrey};
  align-items: center;
  justify-content: center;
`

export const DotInner = styled.div<{ $isActive: boolean }>`
  width: 8px;
  height: 8px;
  background-color: ${({ theme, $isActive }) =>
    $isActive ? theme.color.brandGreen : theme.color.slateGrey};
  border-radius: 50%;
`

export const Arrow = styled.div`
  width: 12px;
  height: 12px;
  transform: rotate(45deg);
  background-color: ${({ theme }) => theme.color.hoverWhite};
  position: absolute;
  right: -25px;

  @media ${device.mobileMin} {
    right: 2px;
    top: -25px;
  }
`

export const Stick = styled.div<{ $percent: number }>`
  width: 2px;
  border-radius: 2px;
  height: 100%;
  background: ${({ theme }) => theme.color.brandGreen};
  background: linear-gradient(
    360deg,
    ${({ theme }) => theme.color.brandGreen} ${({ $percent }) => $percent}%,
    ${({ theme }) => theme.color.lightGrey} ${({ $percent }) => $percent}%
  );

  @media ${device.mobileMin} {
    width: 100%;
    height: 2px;
    border-radius: 2px;
    background: linear-gradient(
      90deg,
      ${({ theme }) => theme.color.brandGreen} ${({ $percent }) => $percent}%,
      ${({ theme }) => theme.color.lightGrey} ${({ $percent }) => $percent}%
    );
  }
`

export const InnerWrapper = styled.div`
  background-color: ${({ theme }) => theme.color.hoverWhite};
  border-radius: 8px;
  padding: 4px 12px 6px 12px;
  align-self: baseline;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    width: 100%;
  }
`

export const ReferAndEarnDetailTitle = styled.div`
  font-size: ${variables.fontSize12};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

export const ReferAndEarnDetailText = styled.div`
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  color: ${({ theme }) => theme.color.darkGrey};
  line-height: 150%;
`

export const ReferAndEarnProgress: FC<ReferAndEarnProgressProps> = ({
  count,
}) => {
  const isStart = count > 0
  const isMiddle = count >= MIDDLE_COUNT
  const isLast = count >= LAST_COUNT
  const firstPercent = (HUNDRED * count) / MIDDLE_COUNT
  const secondPercent =
    (HUNDRED * (count - MIDDLE_COUNT)) / (LAST_COUNT - MIDDLE_COUNT)

  return (
    <OuterWrapper>
      <DotsBlock>
        <DotOuter $isActive={isStart}>
          <DotInner
            data-testid={ReferAndEarnProgressTestId.firstDot}
            $isActive={isStart}
          />
          <Arrow />
        </DotOuter>
        <Stick $percent={firstPercent} />
        <DotOuter $isActive={isMiddle}>
          <DotInner
            data-testid={ReferAndEarnProgressTestId.secondDot}
            $isActive={isMiddle}
          />
          <Arrow />
        </DotOuter>
        <Stick $percent={secondPercent} />
        <DotOuter $isActive={isLast}>
          <DotInner
            data-testid={ReferAndEarnProgressTestId.thirdDot}
            $isActive={isLast}
          />
          <Arrow />
        </DotOuter>
      </DotsBlock>
      <Wrapper>
        <InnerWrapper>
          <ReferAndEarnDetailTitle>
            1-3 referred artists
          </ReferAndEarnDetailTitle>
          <ReferAndEarnDetailText>
            $10 per artist's first campaign
          </ReferAndEarnDetailText>
        </InnerWrapper>
        <InnerWrapper>
          <ReferAndEarnDetailTitle>
            4-9 referred artists
          </ReferAndEarnDetailTitle>
          <ReferAndEarnDetailText>
            $20 per artist's first campaign
          </ReferAndEarnDetailText>
        </InnerWrapper>
        <InnerWrapper>
          <ReferAndEarnDetailTitle>
            from 10 referred artists
          </ReferAndEarnDetailTitle>
          <ReferAndEarnDetailText>
            $50 per artist's first campaign
          </ReferAndEarnDetailText>
        </InnerWrapper>
      </Wrapper>
    </OuterWrapper>
  )
}
